import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cabine } from '@/mocks/cabines';

interface CabineModalProps {
  cabine: Cabine;
  onClose: () => void;
}

export default function CabineModal({ cabine, onClose }: CabineModalProps) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="relative h-72 bg-gray-50 rounded-t-2xl overflow-hidden">
          <img src={cabine.image} alt={cabine.name} className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          <button onClick={onClose} className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-full hover:bg-white transition-colors cursor-pointer">
            <i className="ri-close-line text-gray-700 text-lg"></i>
          </button>
          <div className="absolute bottom-4 left-6 flex gap-2">
            <span className="bg-white/90 backdrop-blur-sm text-gray-700 text-xs font-medium px-3 py-1 rounded-full">{cabine.category}</span>
            {cabine.badge && (
              <span className="bg-[#E8610A] text-white text-xs font-semibold px-3 py-1 rounded-full">{cabine.badge}</span>
            )}
          </div>
        </div>

        <div className="p-8">
          <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-wider mb-1">{cabine.brand}</p>
          <h2 className="text-2xl font-bold text-gray-900 mb-3">{cabine.name}</h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-6">{cabine.description}</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <h3 className="text-gray-900 font-semibold text-sm mb-3">Características</h3>
              <ul className="space-y-2">
                {cabine.features.map((f, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm text-gray-600">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-check-line text-[#E8610A] text-sm"></i>
                    </div>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-gray-900 font-semibold text-sm mb-3">Especificações Técnicas</h3>
              <div className="space-y-2">
                {cabine.specs.map((s, i) => (
                  <div key={i} className="flex justify-between items-center py-1.5 border-b border-gray-50">
                    <span className="text-gray-500 text-xs">{s.label}</span>
                    <span className="text-gray-800 text-xs font-medium">{s.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Link to="/contato" className="flex-1 bg-[#E8610A] text-white text-sm font-medium py-3 rounded-lg text-center hover:bg-[#C4500A] transition-colors whitespace-nowrap cursor-pointer">
              Solicitar Orçamento
            </Link>
            <button onClick={onClose} className="flex-1 border border-gray-200 text-gray-700 text-sm font-medium py-3 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
